import { render, staticRenderFns } from "./DialogSmtpEmailDelete.vue?vue&type=template&id=788b265b&"
import script from "./DialogSmtpEmailDelete.vue?vue&type=script&lang=js&"
export * from "./DialogSmtpEmailDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports